export default "__VITE_ASSET__COhMQWdi__"